import React from "react";
import { Search, Users, MessageCircle, Plane } from "lucide-react";

const steps = [
  {
    number: 1,
    icon: Search,
    title: "Search Destination",
    description: "Choose your destination & travel dates.",
  },
  {
    number: 2,
    icon: Users,
    title: "Find Travelers",
    description: "Discover and connect with verified solo travelers.",
  },
  {
    number: 3,
    icon: MessageCircle,
    title: "Connect & Chat",
    description: "Chat, plan and get to know each other before the trip.",
  },
  {
    number: 4,
    icon: Plane,
    title: "Travel Together",
    description: "Meet up and enjoy unforgettable experiences!",
  },
];

export default function HowItWorks() {
  return (
    <section className="relative z-10 -mt-16 md:-mt-22 pt-24 md:pt-28 pb-6 md:pb-8 bg-[#f4f2fb]">
      {/* <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center "> */}
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12  items-center ">
        {/* Left intro */}
        <div className="lg:col-span-3 ms-3 md:ms-0 mb-10 md:mb-0 lg:mb-0 sm:mb-0" data-aos="fade-right" data-aos-duration="800">
          <span className="inline-block px-4 py-1.5 rounded-full bg-purple-100 text-purple-600 text-xs font-bold  mb-4">
            HOW IT WORKS
          </span>
          <h2 className="text-2xl font-extrabold text-slate-900">
            Travel Together in <br />
            <span className="text-purple-600">4 Simple Steps</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="lg:col-span-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-stretch">
          {steps.map((step, idx) => (
            <React.Fragment key={step.number}>
              <div 
                className="flex-1 relative bg-white rounded-2xl shadow-sm border border-slate-100 pt-8 pb-6 px-5 text-center"
                data-aos="fade-up"
                data-aos-delay={idx * 150}
                data-aos-duration="600"
              >
                <span className="absolute -top-3 left-5 w-6 h-6 rounded-full bg-purple-600 text-white text-xs font-bold flex items-center justify-center">
                  {step.number}
                </span>
                <div className="w-14 h-14 mx-auto rounded-full bg-purple-50 text-purple-600 flex items-center justify-center mb-4">
                  <step.icon className="w-6 h-6" />
                </div>
                <h4 className="font-bold text-sm text-slate-900 mb-1.5">{step.title}</h4>
                <p className="text-xs text-slate-500 leading-relaxed">{step.description}</p>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}